// extracted by mini-css-extract-plugin
export default {"mtn__header":"styles_mtn__header__0hrkz","titleContainer":"styles_titleContainer__OOOcC","dpContainer":"styles_dpContainer__Vk+Md","dp":"styles_dp__0NWxX"};